import { state } from './state'

export default {
    getRates() {
      return state.rates;
    },
  
    getTotalPages() {
      return state.totalPage;
    },

    getTotal() {
      return state.totalItems;
    },
    
    getRate() {
      return state.rate;
    }  
};